<template>
  <div>   
    <v-app-bar 
      app
      color="indigo"
      dark
      flat
      v-model="appBar"
    >
      <!-- tombol drawer -->
      <v-app-bar-nav-icon @click.stop="navIconClick" class="white--text" />
      <!-- judul bar navigasi -->
      <v-toolbar-title class="white--text">
        <span class="font-weight-light">eProc </span>
        <span class="mr-1">SARANA JAYA</span>
      </v-toolbar-title>    
      <v-icon v-if="judul != ''">chevron_right</v-icon>
      <span v-if="judul != ''" class="ml-1 title">{{ judul }}</span>
      <v-spacer></v-spacer>
      <!-- notifikasi -->
      <!-- <v-btn class="ma-2" tile small icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn> -->
      <!-- user profile -->

      <v-chip v-if="vendor" class="ma-2 subtitle-1" color="cyan">
        No. Reg: {{ noRegistrasi }}
      </v-chip>

      <v-chip
        class="ma-2 subtitle-1"
        :color="statusColor"
        text-color="white"
        v-if="vendor"
      >
        <v-avatar left>
          <v-icon>mdi-alert-circle</v-icon>
        </v-avatar>
        {{ statusPerusahaan }}
      </v-chip>


      <!-- Notification -->
      <v-menu :nudge-bottom="40" max-width="300px" max-height="500" bottom :close-on-content-click="false" tile>
        <template v-slot:activator="{ on }">
          <v-btn tile large icon v-on="on">
            <v-badge :content="unreadNotifCount" :value="unreadNotifCount" color="red" overlap>
              <v-icon>mdi-message-text</v-icon>
            </v-badge>
          </v-btn>
        </template>
          <v-list nav>
            <v-list-item-group>
              <v-list-item v-for="(item, index) in notifList" :key="index" @click="notifClick(index)">
                <v-list-item-content>
                  <v-list-item-title v-if="item.isRead">{{getDatefnsFormat(item.tglTampil)}}</v-list-item-title>
                  <v-list-item-title v-else><v-badge color="red" icon="mdi-message">{{getDatefnsFormat(item.tglTampil)}}</v-badge></v-list-item-title>
                  <v-list-item-title v-html="item.namaPengirim"></v-list-item-title>
                  <v-list-item-subtitle v-html="item.pesan"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
      </v-menu>
      

      <v-menu bottom :offset-y="offset">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            tile large icon
            class="mx-4"
          >
            <v-icon>person</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="item.click"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" color="info"></v-icon>
            </v-list-item-icon> 
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>    

    <!-- DIALOG NOTIFICATION -->
    <v-dialog v-model="dlgNotif" max-width="300px">
      <v-card color="#385F73" dark>
        <v-subheader>TANGGAL</v-subheader>
        <v-card-subtitle>{{getDatefnsFormat(viewNotif.tglTampil)}}</v-card-subtitle>
        <v-subheader>PENGIRIM</v-subheader>
        <v-card-subtitle>{{viewNotif.namaPengirim}}</v-card-subtitle>
        <v-subheader>PESAN</v-subheader>
        <v-card-subtitle>{{viewNotif.pesan}}</v-card-subtitle>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

const API_URL = process.env.VUE_APP_ROOT_API
const axios = require('axios').default;
import { format, parseISO } from 'date-fns'


export default {
  data: function() {
    return {
      offset: true,
      items: [
        { title: 'Profil', click: this.profilClick, icon: 'account_box' },
        { title: 'Logout', click: this.logoutClick, icon: 'meeting_rooms' },
      ],

      /* FOR TESTING
      notifList: [
        {
          id: 1,
          tglTampil: "12-03-2020",
          pengirim: "Nama A",
          pesan: "Tolong konfirmasi PPK",
          isRead: false,
        },
        {
          id: 2,
          tglTampil: "13-03-2020",
          pengirim: "Sender 0",
          pesan: "The quick brown fox jumps over the lazy dog. Lorem ipsum dolor blablbalbalbalbalbalblablalbab",
          isRead: true,
        },
        {
          id: 3,
          tglTampil: "14-03-2020",
          pengirim: "Sender 1",
          pesan: "The quick brown fox jumps over the lazy dog. Lorem ipsum dolor blablbalbalbalbalbalblablalbab",
          isRead: false,
        },
        {
          id: 4,
          tglTampil: "15-03-2020",
          pengirim: "Sender 2",
          pesan: "The quick brown fox jumps over the lazy dog. Lorem ipsum dolor blablbalbalbalbalbalblablalbab",
          isRead: false,
        },
        {
          id: 5,
          tglTampil: "11-04-2020",
          pengirim: "Sender 3",
          pesan: "The quick brown fox jumps over the lazy dog. Lorem ipsum dolor blablbalbalbalbalbalblablalbab",
          isRead: true,
        },
        {
          id: 6,
          tglTampil: "12-05-2020",
          pengirim: "Sender 4",
          pesan: "The quick brown fox jumps over the lazy dog. Lorem ipsum dolor blablbalbalbalbalbalblablalbab",
          isRead: false,
        },
        {
          id: 7,
          tglTampil: "12-06-2020",
          pengirim: "Sender 5",
          pesan: "The quick brown fox jumps over the lazy dog. Lorem ipsum dolor blablbalbalbalbalbalblablalbab",
          isRead: true,
        },
        {
          id: 8,
          tglTampil: "13-06-2020",
          pengirim: "Sender 6",
          pesan: "Jangan lupa update password blablablablablabalbal",
          isRead: true,
        },
        {
          id: 9,
          tglTampil: "17-06-2020",
          pengirim: "Sender 7",
          pesan: "Jangan lupa update password blablablablablabalbal",
          isRead: true,
        },
        {
          id: 10,
          tglTampil: "18-06-2020",
          pengirim: "Sender 8",
          pesan: "Jangan lupa update password blablablablablabalbal",
          isRead: true,
        },
        {
          id: 11,
          tglTampil: "19-07-2020",
          pengirim: "Sender 9",
          pesan: "Jangan lupa update password blablablablablabalbal",
          isRead: false,
        },
      ],
      */

      noRegistrasi: "",

      // --- NOTIFICATION --- //
      notifList: [],
      dlgNotif: false,
      viewNotif: {
        id: null,
        tglTampil: new Date().toISOString().substr(0, 10),
        namaPengirim: "",
        pesan: "",
        isRead: false
      },

    }
  },
  computed: {
    appBar: function() {
      return this.$store.getters.isAuthenticated
    },
    judul: function() {
      return this.$store.getters.judul
    },
    statusPerusahaan: function() {      
      return this.$store.getters['ven/venStatusCaption']
    },
    statusColor: function() {
      return this.$store.getters['ven/venStatusCol']
    },
    vendor: function() {
      return this.$store.getters.userRoles === 'vendor' || this.$store.getters.userRoles === 'person'
    },
    userId: function() { 
      return this.$store.getters.userInfo.userId;
    },
    unreadNotifCount: function() {
      let count = 0;
      this.notifList.forEach(element => { if (element.isRead === false) count++; });
      return count;
    },
  },
  methods: {
    navIconClick: function() {
      this.$store.dispatch('toggleDrawer')
    },
    logoutClick: function() {
      this.$store.dispatch('logout')
      .then(() => {
        this.$router.push('/')
      })
    },
    profilClick: function() {
      this.$router.push('/user/profil')
    },
    notifClick: function(index) {
      this.dlgNotif = true;
      this.viewNotif = this.notifList[index];

      if (!this.notifList[index].isRead) {
        axios.put(`${API_URL}/notification/read/${this.viewNotif.id}`)
        .catch( (error) => {
          console.error(error);
        });

        this.notifList[index].isRead = true;
      }

    },
    getDatefnsFormat: function(date) {
      return format(parseISO(date), "dd MMM yyyy")
    },
  },

  created: async function() {
    await axios.get(`${API_URL}/vendor/noreg/${this.userId}`)
    .then( (response) => {
      console.log("No Registrasi: ", response.data);
      this.noRegistrasi = response.data.noRegistrasi;
    })
    .catch( (error) => {
      console.error(error);
    });

    await axios.get(`${API_URL}/notification/${this.userId}`)
    .then( (response) => {
      this.notifList = response.data;
    })
    .catch( (error) => {
      console.error(error);
    })
  },

}
</script>

<style>

</style>